import $ from 'jquery';
import 'slick-carousel';

const breakpoints = [];

export const initCarousel = () => {
  const sliders = document.querySelectorAll('[js-card-carousel-slider]');
  if (sliders) {
    const isGf = document.querySelector('[data-brand="group-first"]') !== null;
    // eslint-disable-next-line no-use-before-define
    setBreakpoints(isGf);

    Array.prototype.forEach.call(sliders, slider => {
      const numSlides = isGf ? 4 : 3;

      $(slider).slick({
        dots: true,
        slidesToShow: numSlides,
        speed: 300,
        prevArrow: $(slider)
          .closest('[js-card-carousel]')
          .find('[js-card-carousel-prev]'),
        nextArrow: $(slider)
          .closest('[js-card-carousel]')
          .find('[js-card-carousel-next]'),
        responsive: breakpoints
      });
    });
  }
};

const setBreakpoints = (isGf) => {
  if(isGf) {
    breakpoints.push({
      breakpoint: 1300,
      settings: {
        infinite: false,
        slidesToShow: 3
      }
    })
  }

  breakpoints.push(
      {
        breakpoint: 800,
        settings: {
          infinite: false,
          slidesToShow: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          infinite: false,
          slidesToShow: 1
        }
      });

  return breakpoints;
}

const locationCardsCarousel = async () => {
  initCarousel();
};

export default locationCardsCarousel;
